import {
  RankedTester,
  rankWith,
  Tester,
  withIncreasedRank,
} from '@jsonforms/core';
import {
  ControlConfiguration,
  ControlConfigurationRendererTester,
} from '@components/uploadForm/Types/ControlConfiguration';

export const uploadFormCreateTester = ({
  controlFunc,
  rank,
  layout,
}: ControlConfiguration | ControlConfigurationRendererTester) => {
  return layout
    ? withIncreasedRank(rank, controlFunc as RankedTester)
    : rankWith(rank, controlFunc as Tester);
};
